
export function setParams(state, params){
    state.params = params
}
export function setLoading(state,bool){
    state.loading.module = bool
}
export function setDateParam(state) {
    // Seteamos la fecha
    var dt = new Date();
    // Fecha Actual
    let d = dt.toISOString().substring(0, 10);
    //Hace 30 Dias
    dt.setDate(dt.getDate() - 30);
    let d1 = dt.toISOString().substring(0, 10);
    state.params.date = [
        d1,
        d,
    ];
}

export function setReport(state, data){
    state.data_report =  data
}




// WEBPACK FOOTER //
// ./src/modules/report-picking/mutations.js